<template>
  <div class="guideDiv">
    <div class="cont1">车辆相关证件拍照指引</div>
    <div class="cont2">
      请严格按照下列要求提供相关证件照片：<br />
      1.请使用横屏拍摄，确保证件完整无任何缺角；<br />
      2.证件上的光线亮度要均匀，无反光现象；<br />
      3.照片上的文件须清晰可见，容易识别；<br />
      <span style="color: #FE3141;">
        4.如提供的照片模糊不清、未符合上述要求，
        我司可能采取但不限于拒绝进厂、拒绝装车、 拒绝卸货等处理措施。
      </span>
    </div>
    <div class="cont3" v-for="(item, index) in 6" :key="index">
      <div>{{ arrListName[index] }}</div>
      <img
        :src="arrListImg[index]"
        alt=""
        class="cont3-img"
        @click="preview_img([], index)"
      />
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  props: {},
  data() {
    return {
      arrListName: [
        "身份证头像面照片样例：",
        "身份证国徽面照片样例：",
        "行驶证主页照片样例：",
        "行驶证副页照片样例：",
        "驾驶证主页照片样例：",
        "驾驶证副页照片样例："
      ],
      arrListImg: [
        require("../assets/img/idcard1.png"),
        require("../assets/img/idcard2.png"),
        require("../assets/img/travel1.png"),
        require("../assets/img/travel2.png"),
        require("../assets/img/driver1.png"),
        require("../assets/img/driver2.png")
      ]
    };
  },
  watch: {},
  components: {},
  async mounted() {},
  methods: {
    preview_img(images, index) {
      ImagePreview({
        images: this.arrListImg, // 图片数组
        showIndex: true,
        loop: true,
        startPosition: index
        // closeable: true
      });
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
.guideDiv {
  padding: 16px;
  font-size: 16px;
  color: #4f4a4c;
  line-height: 26px;
  .cont1 {
    font-size: 21px;
    text-align: center;
    padding: 5px 0px 6px;
  }
  .cont2 {
    color: #4f4a4c;
    padding: 10px 0px 18px;
    line-height: 27px;
  }
  .cont3 {
    font-size: 18px;
    padding: 8px 0px 0px;
    &-img {
      width: 100%;
      object-fit: contain;
      background: #f4f5f6;
      margin: 12px 0px 16px;
    }
  }
}
</style>
